let shareButtonForFacebook = document.querySelector(".js-facebook-share");
let shareButtonForTwitter = document.querySelector(".js-twitter-share");
let shareButtonForWhatsapp = document.querySelector(".js-whatsapp-share");
let shareButtonForInsta = document.querySelector(".js-insta-share");

let buttonAttributeFacebook = shareButtonForFacebook.getAttribute("aria-label");
let buttonAttributeTwitter = shareButtonForTwitter.getAttribute("aria-label");
let buttonAttributeWhatsapp = shareButtonForWhatsapp.getAttribute("aria-label");
let buttonAttributeInsta = shareButtonForInsta.getAttribute("aria-label");


shareButtonForFacebook.addEventListener("click",shareCreatedImage.bind(this, buttonAttributeFacebook),true);
shareButtonForTwitter.addEventListener("click",shareCreatedImage.bind(this, buttonAttributeTwitter),true);
shareButtonForWhatsapp.addEventListener("click",shareCreatedImage.bind(this, buttonAttributeWhatsapp),true);
shareButtonForInsta.addEventListener("click",instaShareImage.bind(this, buttonAttributeInsta),true);



async function shareCreatedImage(buttonName,event){
    console.log(buttonName,event);
    const firstProductJson = JSON.parse(localStorage.getItem("first-step-product")) ? JSON.parse(localStorage.getItem("first-step-product")) : JSON.parse(localStorage.getItem("save-design"))[0];
            const secondProductJson = JSON.parse(localStorage.getItem("second-step-product")) ? JSON.parse(localStorage.getItem("second-step-product")): JSON.parse(localStorage.getItem("save-design"))[1];
            const thirdProductJson = JSON.parse(localStorage.getItem("third-step-product")) ? JSON.parse(localStorage.getItem("third-step-product")) : JSON.parse(localStorage.getItem("save-design"))[2];
            let tag = secondProductJson.tags.find((arr)=>arr.includes("sh_"));
            let splitTag = tag.split("sh_");
            let imgEle1 = document.querySelector(".js-first-step").querySelector("img");
            let imgEle2 = document.querySelector(".js-second-step").querySelector("img");
            let imgEle3 = document.querySelector(".js-third-step").querySelector("img");
            let imgEle4 = document.querySelector(`#${splitTag[1]}`);
            let resEle = document.querySelector(".result");
            var context = resEle.getContext("2d");
            //resEle.width = imgEle1.width;
            //resEle.height = imgEle1.height;
            context.globalAlpha = 1.5;
            context.drawImage(imgEle3, 0, 0, 300, 300);
            context.globalAlpha = 1.0;
            context.drawImage(imgEle1, 50, 50, 200, 350);
            context.globalAlpha = 1;
            context.drawImage(imgEle2, 75, 120, 150, 150);
            context.globalAlpha = 1;
            context.drawImage(imgEle4, 103, 5, 90, 90);
            
            var canvas = document.getElementById('canvas');
            let fileName = 'Bottle-config-product.png'
            var context = canvas.getContext('2d');
                      
            /// create an "off-screen" anchor tag
            var lnk = document.createElement('a'), e;
    
            /// the key here is to set the download attribute of the a tag
            lnk.download = fileName;
    
            /// convert canvas content to data-uri for link. When download
            /// attribute is set the content pointed to by link will be
            /// pushed as "download" in HTML5 capable browsers
            lnk.href = canvas.toDataURL("image/png;base64");
            
            var base64Image = canvas.toDataURL("image/png;base64");
            
            document.getElementById("theimage").src = canvas.toDataURL("image/png;base64");
            
            const contentType = 'image/png'
            const byteCharacters = atob(base64Image.split(',')[1]);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += 512) {
                const slice = byteCharacters.slice(offset, offset + 512);

                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }
        
            // Convert Base64 to Blob
            const blob =  new Blob(byteArrays, { type: contentType });

            // Create a URL for the Blob
            const imageUrl = URL.createObjectURL(blob);
            const imageData = {
                img: base64Image,
                share_button: buttonName
            }

            // Display the image using the URL
            document.getElementById('theimage').src = imageUrl;
            
            // console.log(document.getElementById('theimage').src);
            // let headers = new Headers();

            // headers.append('Content-Type', 'application/json');
            // headers.append('Accept', 'application/json');
          
            // headers.append('Access-Control-Allow-Origin', '*');
            // headers.append('Access-Control-Allow-Credentials', 'false');
  
              $.ajax({
              url: "https://tools.boadiceaperfume.com/social_share.php",
              type: "POST",
              data: JSON.stringify(imageData),
              crossDomain: true,
              headers: {
              "accept": "application/json",
              "Access-Control-Allow-Origin":"*"
              },
              dataType: "JSON",
                success: function(html){
                   window.open(html.link, '_blank', 'noopener,noreferrer');
                }
              });
  
            // headers.append('GET', 'POST', 'OPTIONS');
            // await fetch('https://tools.boadiceaperfume.com/social_share.php', {
            //     method: 'post',
            //     body: JSON.stringify(imageData),
            //     // mode: 'no-cors', // no-cors, *cors, same-origin
            //     headers: {
            //       "accept": "application/json",
            //       "Access-Control-Allow-Origin":"*"  
            //     },
            //   })
            //   // .then((response) => response.json())
            //   .then(data => {
            //     console.log('Success:', data);
            //   })
            //   .catch((error) => {
            //     console.error('Error:', error);
            //   });

}


function instaShareImage(buttonName, event) {
  document.querySelector(".js-insta-details").classList.remove("hidden");
  document.querySelector(".js-details-share-content").classList.add("hidden");
}

document.querySelector(".js-cancel-insta-button").addEventListener("click",function(){
  document.querySelector(".js-insta-details").classList.add("hidden");
  document.querySelector(".js-details-share-content").classList.remove("hidden");
});

